import { gql } from '@apollo/client';

import { setDriver, setPlan, setDocs, setSession } from '../../store';
import { setPhoto, setRent, setLabelV2 } from '../../store/driver';

const GET_INIT_DRIVER = {
  query: gql`
    query Query($uid: ID!) {
      getDriver(uid: $uid) {
        _id
        photo
        createdAt
        updatedAt
        rent {
          carId
        }
        info {
          address
          adrapt
          adrnumber
          birth
          city
          code
          commune
          country
          email
          firstname
          lastname
          phone
          region
          rut
          situation
          gender
          parking
          secondPhone
          emergencyPhone
        }
        status {
          banned
          status
          deleted
          enabled
          verified
          substatus
        }
        verifiedList {
          auth
          tc
          bank
          docs
          info
          meeting
          plan
          app
          guarantee
        }
        docs {
          _id
          files {
            name
            status
            expire
            extension
            url
          }
        }
        plan {
          _id
          plan {
            exclusive
            electric
            name
            active
            shifts {
              _id
            }
          }
          planId
          selectedShifts {
            _id
            startTime
            endTime
            basePrice
            type
          }
        }
        uber {
          _id
          category {
            uberPro
            discount
          }
          firstname
          lastname
          email
          phone
          code
        }
        docs {
          files {
            name
            status
            expire
            extension
            url
          }
        }
      }
    }
  `,
  policies: {
    fetchPolicy: 'no-cache',
    onCompleted: (response) => {
      if (response.getDriver) {
        const {
          _id: driverId,
          info,
          status,
          verifiedList,
          docs,
          plan,
          uber,
          photo,
          rent,
        } = response.getDriver;
        setSession({
          userId: driverId,
          userFirstName: info.firstname,
          userLastName: info.lastname,
          email: info.email,
          verified: status.verified,
        });
        setLabelV2(true);
        info.source = 'Facebook';
        if (uber) {
          setDriver({ info, status, verifiedList, category: uber.category });
        } else {
          setDriver({ info, status, verifiedList });
        }
        setRent(rent);
        setPhoto(photo);
        setDocs(docs.files);
        setPlan(plan);
      }
    },
    errorPolicy: 'ignore',
    context: {
      ignorePattern: {
        pattern: [
          'Error fetching driver rent',
          'Error fetching driver plan',
          'Error fetching uber driver',
        ],
        mandatory: false,
      },
    },
  },
};

export default GET_INIT_DRIVER;
